import { computed, reactive } from "vue";
import { desiredMediaState, realCameraDevice, realMicroDevice } from "./state";
import { locale } from "../../locale";
import { needSync } from "./pipe";

export interface Device {
  deviceId: string;
  deviceName: string;
}

export const cameraDevices = reactive<Device[]>([]);
export const microDevices = reactive<Device[]>([]);
export const audioDevices = reactive<Device[]>([]);

export function cameraDeviceSelectedVisible() {
  return computed(() => {
    if (cameraDevices.length === 0) return locale.deviceLost;
    if (desiredMediaState.cameraDevice) {
      const found = cameraDevices.find(
        (item) => item.deviceId === desiredMediaState.cameraDevice,
      );
      if (found) {
        return found.deviceName;
      } else {
        //Поидее такого не должно быть, но всеже
        return locale.deviceAuto;
      }
    } else {
      if (realCameraDevice.value) {
        const found = cameraDevices.find(
          (item) => item.deviceId === realCameraDevice.value,
        );
        if (found) {
          return found.deviceName;
        } else {
          return locale.deviceAuto;
        }
      } else {
        return locale.deviceAuto;
      }
    }
  });
}

export function microDeviceSelectedVisible() {
  return computed(() => {
    if (microDevices.length === 0) return locale.deviceLost;
    if (desiredMediaState.microDevice) {
      const found = microDevices.find(
        (item) => item.deviceId === desiredMediaState.microDevice,
      );
      if (found) {
        return found.deviceName;
      } else {
        //Поидее такого не должно быть, но всеже
        return locale.deviceAuto;
      }
    } else {
      if (realMicroDevice.value) {
        const found = microDevices.find(
          (item) => item.deviceId === realMicroDevice.value,
        );
        if (found) {
          return found.deviceName;
        } else {
          return locale.deviceAuto;
        }
      } else {
        return locale.deviceAuto;
      }
    }
  });
}

export function audioDeviceSelectedVisible() {
  return computed(() => {
    if (audioDevices.length === 0) return locale.deviceLost;
    if (desiredMediaState.audioDevice) {
      const found = audioDevices.find(
        (item) => item.deviceId === desiredMediaState.audioDevice,
      );
      if (found) {
        return found.deviceName;
      } else {
        //Поидее такого не должно быть, но всеже
        return locale.deviceAuto;
      }
    } else {
      return locale.deviceAuto;
    }
  });
}

const LOCAL_STORAGE_SAVED_DEVICES_KEY = "savedDevices";

function loadDevices() {
  const savedLocalData = localStorage.getItem(LOCAL_STORAGE_SAVED_DEVICES_KEY);
  if (savedLocalData) {
    try {
      const data = JSON.parse(savedLocalData);
      if (data.camera) desiredMediaState.cameraDevice = data.camera;
      if (data.micro) desiredMediaState.microDevice = data.micro;
      if (data.audio) desiredMediaState.audioDevice = data.audio;
    } catch (err) {
      localStorage.removeItem(LOCAL_STORAGE_SAVED_DEVICES_KEY);
      console.log("error parse saved local data", err);
    }
  }
}

export function saveDevicesInStorrage() {
  localStorage.setItem(
    LOCAL_STORAGE_SAVED_DEVICES_KEY,
    JSON.stringify({
      camera: desiredMediaState.cameraDevice,
      micro: desiredMediaState.microDevice,
      audio: desiredMediaState.audioDevice,
    }),
  );
}

export function initDevices() {
  loadDevices();
  //@ts-ignore
  if (navigator.mediaDevices?.enumerateDevices) {
    navigator.mediaDevices.ondevicechange = () => {
      onDevicesChange();
    };
  }
}

async function onDevicesChange() {
  await fillDeviceList()
}

export async function fillDeviceList() {
  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    const cameras = devices
      .filter((device) => device.kind === "videoinput" && device.deviceId)
      .map((device) => {
        return {
          deviceId: device.deviceId,
          deviceName: device.label,
        };
      });
    const microphones = devices
      .filter((device) => device.kind === "audioinput" && device.deviceId)
      .map((device) => {
        return {
          deviceId: device.deviceId,
          deviceName: device.label,
        };
      });
    const audiooutputs = devices
      .filter((device) => device.kind === "audiooutput" && device.deviceId)
      .map((device) => {
        return {
          deviceId: device.deviceId,
          deviceName: device.label,
        };
      });
    cameraDevices.length = 0;
    microDevices.length = 0;
    audioDevices.length = 0;
    cameraDevices.push(...cameras);
    microDevices.push(...microphones);
    audioDevices.push(...audiooutputs);
    needSync()
  } catch {
    cameraDevices.length = 0;
    microDevices.length = 0;
    audioDevices.length = 0;
  }
}
